document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-seednary-header-menu]").forEach((header) => {
    const openButton = header.querySelector("[data-seednary-mobile-toggle]");
    const closeButton = header.querySelector("[data-seednary-mobile-close]");
    const primaryButtons = header.querySelectorAll("[data-seednary-mobile-primary]");
    const panels = header.querySelectorAll("[data-seednary-mobile-panel]");

    openButton?.addEventListener("click", () => {
      header.classList.add("is-mobile-open");
    });

    closeButton?.addEventListener("click", () => {
      header.classList.remove("is-mobile-open");
    });

    primaryButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const index = button.dataset.seednaryMobilePrimary;
        primaryButtons.forEach((item) => item.classList.remove("is-active"));
        panels.forEach((panel) => panel.classList.toggle("is-active", panel.dataset.seednaryMobilePanel === index));
        button.classList.add("is-active");
      });
    });

    header.querySelectorAll(".seednary-mobile-accordion__button").forEach((button) => {
      button.addEventListener("click", () => {
        const accordion = button.closest(".seednary-mobile-accordion");
        const isOpen = accordion.classList.contains("is-open");
        accordion.classList.toggle("is-open", !isOpen);
        button.setAttribute("aria-expanded", String(!isOpen));
      });
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        header.classList.remove("is-mobile-open");
      }
    });
  });
});
